import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withCtx as _withCtx, vModelText as _vModelText, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card mb-8"
}
const _hoisted_2 = { class: "card-body pb-4" }
const _hoisted_3 = {
  class: "accordion",
  id: "kt_accordion_1"
}
const _hoisted_4 = { class: "accordion-item" }
const _hoisted_5 = {
  class: "accordion-header",
  id: "kt_accordion_1_header_1"
}
const _hoisted_6 = {
  class: "accordion-button fs-4 fw-bold text-dark",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_accordion_1_body_1",
  "aria-expanded": "true",
  "aria-controls": "kt_accordion_1_body_1"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-hospital-user icon-accordion" }, null, -1)
const _hoisted_8 = {
  id: "kt_accordion_1_body_1",
  class: "accordion-collapse collapse show",
  "aria-labelledby": "kt_accordion_1_header_1",
  "data-bs-parent": "#kt_accordion_1"
}
const _hoisted_9 = { class: "accordion-body" }
const _hoisted_10 = { class: "d-flex" }
const _hoisted_11 = { class: "report-info-box" }
const _hoisted_12 = { class: "box-text" }
const _hoisted_13 = { class: "box-label" }
const _hoisted_14 = { class: "report-info-box" }
const _hoisted_15 = { class: "box-text" }
const _hoisted_16 = { class: "box-label" }
const _hoisted_17 = { class: "d-flex" }
const _hoisted_18 = { class: "report-info-box" }
const _hoisted_19 = { class: "box-text" }
const _hoisted_20 = { class: "box-label" }
const _hoisted_21 = { class: "report-info-box" }
const _hoisted_22 = { class: "box-text" }
const _hoisted_23 = { class: "box-label" }
const _hoisted_24 = { class: "d-flex" }
const _hoisted_25 = { class: "report-info-box text-capitalize" }
const _hoisted_26 = { class: "box-text" }
const _hoisted_27 = { class: "box-label" }
const _hoisted_28 = {
  key: 0,
  class: "d-flex mt-5"
}
const _hoisted_29 = {
  class: "",
  style: {"border-top":"1px solid #122af3","padding":"20px 0px 0px 0px"}
}
const _hoisted_30 = { class: "col-lg-2 p-2 mb-5" }
const _hoisted_31 = { class: "d-flex align-items-center float-start" }
const _hoisted_32 = ["src"]
const _hoisted_33 = { class: "pa-col-info col-lg-7 mt-2" }
const _hoisted_34 = { class: "fw-bolder fs-4 mb-1" }
const _hoisted_35 = { class: "text-gray-400" }
const _hoisted_36 = { class: "col-lg-12 mt-5" }
const _hoisted_37 = { class: "fw-bolder mobile_f12-18" }
const _hoisted_38 = { class: "mt-2 mb-4 mobile_f10-15" }
const _hoisted_39 = ["href"]
const _hoisted_40 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-phone fs-4" }, null, -1)
const _hoisted_41 = ["href"]
const _hoisted_42 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar fs-4" }, null, -1)
const _hoisted_43 = { class: "row g-5 gx-xxl-12" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", { style: {"padding":"10px","margin":"0px"} }, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "fa fa-hospital-user",
    style: {"color":"#122af3 !important"}
  })
], -1)
const _hoisted_45 = { class: "report-info-box" }
const _hoisted_46 = { class: "box-text" }
const _hoisted_47 = { class: "box-label" }
const _hoisted_48 = { class: "report-info-box" }
const _hoisted_49 = { class: "box-text" }
const _hoisted_50 = { class: "box-label" }
const _hoisted_51 = { class: "report-info-box" }
const _hoisted_52 = { class: "box-text" }
const _hoisted_53 = { class: "box-label" }
const _hoisted_54 = { class: "report-info-box" }
const _hoisted_55 = { class: "box-text" }
const _hoisted_56 = { class: "box-label" }
const _hoisted_57 = { class: "report-info-box text-capitalize" }
const _hoisted_58 = { class: "box-text" }
const _hoisted_59 = { class: "box-label" }
const _hoisted_60 = {
  class: "row",
  style: {"padding-left":"20px"}
}
const _hoisted_61 = { class: "col-lg-12" }
const _hoisted_62 = { class: "col-lg-2 p-2" }
const _hoisted_63 = {
  class: "d-flex align-items-center",
  style: {}
}
const _hoisted_64 = ["src"]
const _hoisted_65 = { class: "col-lg-7 mt-5 ms-3" }
const _hoisted_66 = { class: "fw-bolder fs-4 mb-1" }
const _hoisted_67 = { class: "text-gray-400" }
const _hoisted_68 = { class: "col-lg-12 mt-5" }
const _hoisted_69 = { class: "fw-bolder fs-5" }
const _hoisted_70 = { class: "mt-2 mb-4" }
const _hoisted_71 = ["href"]
const _hoisted_72 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-phone fs-4" }, null, -1)
const _hoisted_73 = ["href"]
const _hoisted_74 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar fs-4" }, null, -1)
const _hoisted_75 = {
  class: "col-xxl-4",
  style: {"border-left":"20px solid #122af3","border-radius":"20px"}
}
const _hoisted_76 = {
  class: "row",
  style: {"padding-left":"20px"}
}
const _hoisted_77 = { class: "col-lg-12" }
const _hoisted_78 = { class: "col-lg-12 mt-5" }
const _hoisted_79 = { class: "mt-2 mb-4" }
const _hoisted_80 = { class: "mt-2 mb-4 fw-bolder" }
const _hoisted_81 = { class: "fw-light" }
const _hoisted_82 = { class: "card-body pb-4" }
const _hoisted_83 = { class: "row g-5 gx-xxl-12" }
const _hoisted_84 = { class: "widget-consent-border alert d-block p-5 mb-10 p-5 mb-10" }
const _hoisted_85 = /*#__PURE__*/_createElementVNode("div", { class: "" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "consent-info-icon svg-icon svg-icon-2hx svg-icon-dark me-4" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "bi bi-info-circle-fill fs-1 text-white" })
  ])
], -1)
const _hoisted_86 = { class: "d-flex align-items-center" }
const _hoisted_87 = { class: "d-flex flex-column pb-5" }
const _hoisted_88 = { class: "mb-1 text-dark" }
const _hoisted_89 = { class: "w-100" }
const _hoisted_90 = { class: "w-100" }
const _hoisted_91 = { class: "row pt-1" }
const _hoisted_92 = { class: "form-check form-check-custom form-check-dark pe-5" }
const _hoisted_93 = { class: "form-check-label text-gray-800 ps-2" }
const _hoisted_94 = ["href"]
const _hoisted_95 = ["href"]
const _hoisted_96 = { class: "fv-plugins-message-container" }
const _hoisted_97 = { class: "fv-help-block" }
const _hoisted_98 = { class: "text-gray-400" }
const _hoisted_99 = { class: "text-gray-400" }
const _hoisted_100 = { class: "col-xxl-2" }
const _hoisted_101 = /*#__PURE__*/_createElementVNode("input", {
  type: "text",
  name: "lead_type",
  class: "d-none",
  value: "Patient"
}, null, -1)
const _hoisted_102 = /*#__PURE__*/_createElementVNode("input", {
  type: "text",
  name: "referred_type",
  id: "referred_type",
  class: "d-none",
  value: "Patient Platform"
}, null, -1)
const _hoisted_103 = ["value"]
const _hoisted_104 = ["value"]
const _hoisted_105 = /*#__PURE__*/_createElementVNode("input", {
  type: "text",
  name: "medical_record_forms_received",
  class: "d-none",
  value: "Yes"
}, null, -1)
const _hoisted_106 = /*#__PURE__*/_createElementVNode("input", {
  type: "text",
  name: "hs_content_membership_notes",
  class: "d-none",
  value: ""
}, null, -1)
const _hoisted_107 = ["disabled"]
const _hoisted_108 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-signature text-white fs-4" }, null, -1)
const _hoisted_109 = { class: "indicator-label" }
const _hoisted_110 = { class: "indicator-progress" }
const _hoisted_111 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_112 = { class: "card" }
const _hoisted_113 = { class: "col-xxl-12" }
const _hoisted_114 = {
  class: "modal modal-xl fade",
  tabindex: "-1",
  id: "kt_modal_1"
}
const _hoisted_115 = { class: "modal-dialog" }
const _hoisted_116 = { class: "modal-content" }
const _hoisted_117 = { class: "modal-header" }
const _hoisted_118 = { class: "modal-title" }
const _hoisted_119 = /*#__PURE__*/_createElementVNode("div", {
  class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2x" })
], -1)
const _hoisted_120 = { class: "modal-body" }
const _hoisted_121 = {
  key: 0,
  class: "consent-check-group"
}
const _hoisted_122 = ["innerHTML"]
const _hoisted_123 = /*#__PURE__*/_createElementVNode("div", { class: "modal-footer" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn btn-primary",
    "data-bs-dismiss": "modal"
  }, " Okay ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MBloader = _resolveComponent("MBloader")!
  const _component_Field = _resolveComponent("Field")!
  const _component_i18n_t = _resolveComponent("i18n-t")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!
  const _component_WidgetReportProcessing = _resolveComponent("WidgetReportProcessing")!
  const _component_ConsentCheck = _resolveComponent("ConsentCheck")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_MBloader, { MedicalRecordsTableLoaded: _ctx.isPatientValuesLoading }, null, 8, ["MedicalRecordsTableLoaded"]),
    (_ctx.isPatientValuesLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _withDirectives(_createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("h2", _hoisted_5, [
                    _createElementVNode("button", _hoisted_6, [
                      _hoisted_7,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t("Facesheet")), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.patient_values.first_name) + " " + _toDisplayString(_ctx.patient_values.last_name), 1),
                          _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t("Patient Name")), 1)
                        ]),
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.patient_values.age), 1),
                          _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t("Age")), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.patient_values.zip), 1),
                          _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$t("Zip Code")), 1)
                        ]),
                        _createElementVNode("div", _hoisted_21, [
                          _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.$t(_ctx.patient_values.cancer_type_title)), 1),
                          _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.$t("Cancer Type")), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("div", _hoisted_25, [
                          _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.patient_values.sex), 1),
                          _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.$t("Gender")), 1)
                        ])
                      ]),
                      (_ctx.patient_values.patient_advocate_name)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                            _createElementVNode("div", _hoisted_29, [
                              _createElementVNode("div", _hoisted_30, [
                                _createElementVNode("div", _hoisted_31, [
                                  _createElementVNode("img", {
                                    src: _ctx.patient_values.patient_advocate_image,
                                    style: {"border-radius":"50%","padding":"2px","box-shadow":"0 0 0 3px #fff, 0 0 0 4px #ddd","width":"70px","height":"auto"}
                                  }, null, 8, _hoisted_32)
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_33, [
                                _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.patient_values.patient_advocate_name), 1),
                                _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.$t(_ctx.patient_values.patient_advocate_title)), 1)
                              ]),
                              _createElementVNode("div", _hoisted_36, [
                                _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.$t(
                            "Our patient relations coordinator will contact you to give more information and answer any questions you have."
                          )), 1),
                                _createElementVNode("div", _hoisted_38, _toDisplayString(_ctx.$t("You can contact us any time at the number below.")), 1),
                                _createElementVNode("a", {
                                  href: `tel:${_ctx.$t('MassiveBioPhoneNumber')}`,
                                  class: "btn btn-secondary btn-sm fw-normal text-dark me-2 mb-2"
                                }, [
                                  _hoisted_40,
                                  _createTextVNode(" " + _toDisplayString(_ctx.$t("Call Now")), 1)
                                ], 8, _hoisted_39),
                                _createElementVNode("a", {
                                  href: _ctx.patient_values.schedule_link,
                                  class: "btn btn-secondary btn-sm fw-normal text-dark me-2 mb-2",
                                  target: "_blank"
                                }, [
                                  _hoisted_42,
                                  _createTextVNode(" " + _toDisplayString(_ctx.$t("Schedule a Call")), 1)
                                ], 8, _hoisted_41)
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ])
            ], 512), [
              [_vShow, _ctx.ismobile]
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_43, [
              _createElementVNode("div", {
                class: _normalizeClass({
            'col-xxl-4': _ctx.isCtmsTabActive,
            'col-xxl-6': !_ctx.isCtmsTabActive,
          })
              }, [
                _hoisted_44,
                _createElementVNode("div", _hoisted_45, [
                  _createElementVNode("div", _hoisted_46, _toDisplayString(_ctx.patient_values.first_name) + " " + _toDisplayString(_ctx.patient_values.last_name), 1),
                  _createElementVNode("div", _hoisted_47, _toDisplayString(_ctx.$t("Patient Name")), 1)
                ]),
                _createElementVNode("div", _hoisted_48, [
                  _createElementVNode("div", _hoisted_49, _toDisplayString(_ctx.patient_values.age), 1),
                  _createElementVNode("div", _hoisted_50, _toDisplayString(_ctx.$t("Age")), 1)
                ]),
                _createElementVNode("div", _hoisted_51, [
                  _createElementVNode("div", _hoisted_52, _toDisplayString(_ctx.patient_values.zip), 1),
                  _createElementVNode("div", _hoisted_53, _toDisplayString(_ctx.$t("Zip Code")), 1)
                ]),
                _createElementVNode("div", _hoisted_54, [
                  _createElementVNode("div", _hoisted_55, _toDisplayString(_ctx.$t(_ctx.patient_values.cancer_type_title)), 1),
                  _createElementVNode("div", _hoisted_56, _toDisplayString(_ctx.$t("Cancer Type")), 1)
                ]),
                _createElementVNode("div", _hoisted_57, [
                  _createElementVNode("div", _hoisted_58, _toDisplayString(_ctx.patient_values.sex), 1),
                  _createElementVNode("div", _hoisted_59, _toDisplayString(_ctx.$t("Gender")), 1)
                ])
              ], 2),
              (_ctx.patient_values.patient_advocate_name)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass({
            'col-xxl-4': _ctx.isCtmsTabActive,
            'col-xxl-6': !_ctx.isCtmsTabActive,
          }),
                    style: {"border-left":"1px solid #122af3"}
                  }, [
                    _createElementVNode("div", _hoisted_60, [
                      _createElementVNode("div", _hoisted_61, [
                        _createElementVNode("h2", null, _toDisplayString(_ctx.$t("Your Patient Relations Coordinator")), 1)
                      ]),
                      _createElementVNode("div", _hoisted_62, [
                        _createElementVNode("div", _hoisted_63, [
                          _createElementVNode("img", {
                            src: _ctx.patient_values.patient_advocate_image,
                            style: {"border-radius":"50%","padding":"2px","box-shadow":"0 0 0 3px #fff, 0 0 0 4px #ddd","width":"70px","height":"auto"}
                          }, null, 8, _hoisted_64)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_65, [
                        _createElementVNode("div", _hoisted_66, _toDisplayString(_ctx.patient_values.patient_advocate_name), 1),
                        _createElementVNode("div", _hoisted_67, _toDisplayString(_ctx.$t(_ctx.patient_values.patient_advocate_title)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_68, [
                        _createElementVNode("div", _hoisted_69, _toDisplayString(_ctx.$t(
                    "Our patient relations coordinator will contact you to give more information and answer any questions you have."
                  )), 1),
                        _createElementVNode("div", _hoisted_70, _toDisplayString(_ctx.$t("You can contact us any time at the number below.")), 1),
                        _createElementVNode("a", {
                          href: `tel:${_ctx.$t('MassiveBioPhoneNumber')}`,
                          class: "btn btn-secondary btn-sm fw-normal text-dark me-2 mb-2"
                        }, [
                          _hoisted_72,
                          _createTextVNode(" " + _toDisplayString(_ctx.$t("Call Now")), 1)
                        ], 8, _hoisted_71),
                        _createElementVNode("a", {
                          href: _ctx.patient_values.schedule_link,
                          class: "btn btn-secondary btn-sm fw-normal text-dark me-2 mb-2",
                          target: "_blank"
                        }, [
                          _hoisted_74,
                          _createTextVNode(" " + _toDisplayString(_ctx.$t("Schedule a Call")), 1)
                        ], 8, _hoisted_73)
                      ])
                    ])
                  ], 2))
                : _createCommentVNode("", true),
              _withDirectives(_createElementVNode("div", _hoisted_75, [
                _createElementVNode("div", _hoisted_76, [
                  _createElementVNode("div", _hoisted_77, [
                    _createElementVNode("h2", null, _toDisplayString(_ctx.$t("Dear")) + " " + _toDisplayString(_ctx.patient_values.first_name), 1)
                  ]),
                  _createElementVNode("div", _hoisted_78, [
                    _createElementVNode("div", _hoisted_79, [
                      _createElementVNode("p", null, _toDisplayString(_ctx.$t("SelinLetterSection_1")), 1),
                      _createElementVNode("p", null, _toDisplayString(_ctx.$t("SelinLetterSection_2")), 1),
                      _createElementVNode("p", null, _toDisplayString(_ctx.$t("SelinLetterSection_3")), 1),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t("Thank you,")), 1)
                    ]),
                    _createElementVNode("div", _hoisted_80, [
                      _createTextVNode(" Selin Kurnaz, "),
                      _createElementVNode("p", _hoisted_81, _toDisplayString(_ctx.$t("PhD Co-Founder & CEO Massive Bio Inc.")), 1)
                    ])
                  ])
                ])
              ], 512), [
                [_vShow, _ctx.isCtmsTabActive]
              ])
            ], 512), [
              [_vShow, !_ctx.ismobile]
            ])
          ]),
          _createElementVNode("div", _hoisted_82, [
            _createElementVNode("div", _hoisted_83, [
              _createElementVNode("div", {
                class: _normalizeClass(["col-xxl-12", { 'd-block': !_ctx.consent_status }]),
                style: {"display":"none"}
              }, [
                _createVNode(_component_Form, {
                  class: "form w-100 fv-plugins-bootstrap5 fv-plugins-framework",
                  id: "consent_sign_form",
                  "validation-schema": _ctx.consentchecker,
                  onSubmit: _ctx.changeStatus,
                  novalidate: "novalidate"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_84, [
                      _hoisted_85,
                      _createElementVNode("div", _hoisted_86, [
                        _createElementVNode("div", _hoisted_87, [
                          _createElementVNode("h4", _hoisted_88, _toDisplayString(_ctx.$t(
                        "There is no guarantee of eligibility for clinical trial search results."
                      )), 1),
                          _createElementVNode("div", _hoisted_89, _toDisplayString(_ctx.$t("ClinicalTrialDisclaimer")), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_90, [
                        _createElementVNode("div", _hoisted_91, [
                          _createElementVNode("div", {
                            class: _normalizeClass(["col-xxl-6 pt-2", { 'mb-3': _ctx.ismobile }])
                          }, [
                            _createElementVNode("label", _hoisted_92, [
                              _createVNode(_component_Field, {
                                class: "form-check-input",
                                type: "checkbox",
                                value: true,
                                name: "consent_checkbox",
                                id: "consent_checkbox",
                                onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.consentChange($event))),
                                disabled: !_ctx.consentGroupChecked
                              }, null, 8, ["disabled"]),
                              _createElementVNode("div", _hoisted_93, [
                                _createVNode(_component_i18n_t, {
                                  keypath: "synergyFormAcceptance",
                                  class: "form-check-label text-gray-800 ps-2"
                                }, {
                                  synergy: _withCtx(() => [
                                    _createElementVNode("a", {
                                      href: _ctx.syngergyAIConsentUrl,
                                      target: "_blank",
                                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.getText('synergyai'))),
                                      "data-bs-toggle": "modal",
                                      "data-bs-target": "#kt_modal_1"
                                    }, _toDisplayString(_ctx.$t("Synergy AI HIPAA/GDPR release form")), 9, _hoisted_94)
                                  ]),
                                  policy: _withCtx(() => [
                                    _createElementVNode("a", {
                                      href: _ctx.privacyPolicyUrl,
                                      target: "_blank",
                                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.getText('privacy'))),
                                      "data-bs-toggle": "modal",
                                      "data-bs-target": "#kt_modal_1"
                                    }, _toDisplayString(_ctx.$t("Privacy Policy")), 9, _hoisted_95)
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_96, [
                              _createElementVNode("div", _hoisted_97, [
                                _createVNode(_component_ErrorMessage, {
                                  name: "consent_checkbox",
                                  class: _normalizeClass({ 'mobile_f10-15': _ctx.ismobile })
                                }, null, 8, ["class"])
                              ])
                            ])
                          ], 2),
                          _createElementVNode("div", {
                            class: _normalizeClass(["col-xxl-2", { 'mobile_f10-15': _ctx.ismobile }])
                          }, [
                            _createElementVNode("span", _hoisted_98, _toDisplayString(_ctx.$t("Patient signature")), 1),
                            _createElementVNode("div", {
                              class: _normalizeClass(["border-bottom border-third signature", { 'pt-4': !_ctx.ismobile, 'pt-2': _ctx.ismobile }])
                            }, _toDisplayString(_ctx.patient_values.first_name) + " " + _toDisplayString(_ctx.patient_values.last_name), 3)
                          ], 2),
                          _createElementVNode("div", {
                            class: _normalizeClass(["col-xxl-2", { 'mobile_f10-15 mt-3': _ctx.ismobile }])
                          }, [
                            _createElementVNode("span", _hoisted_99, _toDisplayString(_ctx.$t("Date")), 1),
                            _createElementVNode("div", {
                              class: _normalizeClass(["border-bottom border-third", { 'pt-4': !_ctx.ismobile, 'pt-2': _ctx.ismobile }])
                            }, _toDisplayString(_ctx.currentDateTime), 3)
                          ], 2),
                          _createElementVNode("div", _hoisted_100, [
                            _createElementVNode("div", {
                              class: _normalizeClass(["py-1 fs-5", { 'float-end px-1 ': !_ctx.ismobile }])
                            }, [
                              _hoisted_101,
                              _hoisted_102,
                              _createElementVNode("input", {
                                type: "text",
                                name: "form_language",
                                class: "d-none",
                                value: _ctx.currentLocale.toUpperCase()
                              }, null, 8, _hoisted_103),
                              _createElementVNode("input", {
                                type: "text",
                                name: "mbi_products",
                                class: "d-none",
                                value: 
                          _ctx.currentLocale === 'en'
                            ? 'CTMS'
                            : 'CTMS - International'
                        
                              }, null, 8, _hoisted_104),
                              _hoisted_105,
                              _hoisted_106,
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                name: "email",
                                class: "d-none",
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.patient_s_email) = $event))
                              }, null, 512), [
                                [_vModelText, _ctx.patient_s_email]
                              ]),
                              _createElementVNode("button", {
                                id: "kt_sign_up_submit",
                                ref: "submitButton",
                                type: "submit",
                                class: _normalizeClass(["btn btn-lg btn-primary ctmscolor_background", { 'w-100 btn-sm mt-3': _ctx.ismobile }]),
                                disabled: !_ctx.consentGroupChecked
                              }, [
                                _hoisted_108,
                                _createElementVNode("span", _hoisted_109, _toDisplayString(_ctx.$t("Sign Now")), 1),
                                _createElementVNode("span", _hoisted_110, [
                                  _createTextVNode(_toDisplayString(_ctx.$t("Please wait")) + "... ", 1),
                                  _hoisted_111
                                ])
                              ], 10, _hoisted_107)
                            ], 2)
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _: 1
                }, 8, ["validation-schema", "onSubmit"])
              ], 2)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_112, [
      _createElementVNode("div", _hoisted_113, [
        _withDirectives(_createVNode(_component_WidgetReportProcessing, { ref: "refWidgetReportProcessing" }, null, 512), [
          [_vShow, _ctx.report_status_area]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_114, [
      _createElementVNode("div", _hoisted_115, [
        _createElementVNode("div", _hoisted_116, [
          _createElementVNode("div", _hoisted_117, [
            _createElementVNode("h5", _hoisted_118, _toDisplayString(_ctx.policyTitle), 1),
            _hoisted_119
          ]),
          _createElementVNode("div", _hoisted_120, [
            (_ctx.policyCheckList.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_121, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.policyCheckList, (consentCheckContent, index) => {
                    return (_openBlock(), _createBlock(_component_ConsentCheck, {
                      content: consentCheckContent.value,
                      index: index,
                      checked: consentCheckContent.checked,
                      onChange: _ctx.handleConsentCheckChange,
                      key: `consent-check-${index}`
                    }, null, 8, ["content", "index", "checked", "onChange"]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: "policy-content",
              innerHTML: _ctx.policyContent
            }, null, 8, _hoisted_122)
          ]),
          _hoisted_123
        ])
      ])
    ])
  ], 64))
}